export const home = {
  heroTitle: "Sälj din pryl på",
  heroTitleAccent: "några sekunder",
  heroSubtitle: "Fota prylen – du får färdig annonstext och ett prisförslag.",
  draftSaved: "Du har ett sparat utkast.",
  draftContinue: "Fortsätt där du slutade",
  sheetTitle: "Vad vill du sälja?",
  sheetDescription: "Välj hur du vill komma i gång.",
  ctaTitle: "Fota din pryl – vi skriver annonsen",
  ctaSubtitle: "Ta en bild – du får text och prisförslag, och publicerar gratis.",
  ctaButton: "Kom igång",
  latestTitle: "Senaste annonserna",
  latestSubtitle: "Från hela Sverige.",
  seeAll: "Se alla annonser",
  empty: "Inga annonser ännu — bli först med att publicera en.",
} as const;
